{
    "Profile_Insured.applicantDetails": "FR: Insured Applicant Details",
    "Profile_Insured.name": "FR: Name",
    "Profile_Insured.communicationDetails": "FR: Insured Contact Details",
    "Profile_Insured.contactDetails": "FR: Contact Details",
    "Profile_Insured.email": "FR: Email",
    "Profile_Insured.phone": "FR: Phone",
    "Profile_Insured.mobile": "FR: Mobile",
    "Profile_Insured.addressDetails": "FR: Insured Risk Address",
    "Profile_Insured.locationDetails": "FR: Location Details",
    "Profile_Insured.previousAddressDetails": "FR: Previous Address Details",
    "Profile_Insured.mailingAddressDetails": "FR: Insured Mailing Address",
    "Profile_Insured.mailingAddressSameAsAbove": "FR: Mailing Address same as above address",
    "Profile_Insured.warning": "FR: Warning",
    "Profile_Insured.stateChangeWarning": "FR: Coverage limits vary by state. Please reselect a different coverage limit according to the new state.",
    "Profile_Insured.ok": "FR: OK",
    "Profile_Insured.cancel": "FR: Cancel"
}
